import $ from 'jquery'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const hamburger = $('.js-hamburger');

hamburger.on('click', function () {
  if ($(this).hasClass('is-active')) {
    $('body').removeClass('menu-open');
    $(this).removeClass('is-active');
    enableBodyScroll($('.nav')[0]);
  } else {
    $('body').addClass('menu-open');
    $(this).addClass('is-active');
    disableBodyScroll($('.nav')[0]);
  }
});